var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "margin-dialog-body" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.dialogConfirmacao,
            callback: function($$v) {
              _vm.dialogConfirmacao = $$v
            },
            expression: "dialogConfirmacao"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline primary--text" }, [
                _vm._v("Deseja realmente modificar o título?")
              ]),
              _c(
                "v-card-text",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.dialogResponse,
                      expression: "!dialogResponse"
                    }
                  ]
                },
                [
                  _vm._v(
                    "Esta modificação é definitiva e automaticamente disponibilizará o título para protesto!"
                  )
                ]
              ),
              _c(
                "v-card-text",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.dialogResponse,
                      expression: "dialogResponse"
                    }
                  ]
                },
                [_vm._v("Título modificado com sucesso!")]
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.dialogResponse,
                          expression: "!dialogResponse"
                        }
                      ],
                      attrs: {
                        "data-cy": "simCorrecao",
                        color: "green darken-1",
                        text: ""
                      },
                      on: { click: _vm.correcaoTitulo }
                    },
                    [_vm._v("Sim")]
                  ),
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.dialogResponse,
                          expression: "!dialogResponse"
                        }
                      ],
                      attrs: { color: "red darken-1", text: "" },
                      on: { click: _vm.fechaConfirmacao }
                    },
                    [_vm._v("Não")]
                  ),
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dialogResponse,
                          expression: "dialogResponse"
                        }
                      ],
                      attrs: { color: "green darken-1", text: "" },
                      on: { click: _vm.fechaConfirmacao }
                    },
                    [_vm._v("Ok!")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            transition: "dialog-bottom-transition",
            width: "450px"
          },
          model: {
            value: _vm.loading,
            callback: function($$v) {
              _vm.loading = $$v
            },
            expression: "loading"
          }
        },
        [
          _c(
            "div",
            { staticClass: "text-center", attrs: { width: "420px" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-progress-circular",
                    {
                      staticClass: "ma-12",
                      attrs: {
                        indeterminate: "",
                        size: "150",
                        color: "primary"
                      }
                    },
                    [_vm._v("Carregando...")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "v-card",
        { attrs: { "max-width": "900px" } },
        [
          _c(
            "v-toolbar",
            {
              staticClass: "mb-5",
              attrs: { flat: "", dark: "", color: "primary" }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  on: { click: _vm.fechaConfirmacao }
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
              _c("v-toolbar-title", [_vm._v("Correção de Nome e Endereço")])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ma-3" },
            [
              _c(
                "v-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.ativaCardNome,
                      expression: "ativaCardNome"
                    }
                  ],
                  staticClass: "pa-2 mb-4"
                },
                [
                  _c("v-card-title", { staticClass: "mt-n4 primary--text" }, [
                    _vm._v("Nome")
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      denses: "",
                      label: "Nome Devedor Atual",
                      readonly: ""
                    },
                    model: {
                      value: _vm.detalhe_titulo.nm_devedor,
                      callback: function($$v) {
                        _vm.$set(_vm.detalhe_titulo, "nm_devedor", $$v)
                      },
                      expression: "detalhe_titulo.nm_devedor"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "data-cy": "nomeAbreviado",
                      outlined: "",
                      dense: "",
                      label: "Nome Devedor Abreviado",
                      counter: 45,
                      rules: [_vm.validadorNome.required, _vm.validadorNome.min]
                    },
                    model: {
                      value: _vm.detalhe_titulo.nm_devedor_cra,
                      callback: function($$v) {
                        _vm.$set(_vm.detalhe_titulo, "nm_devedor_cra", $$v)
                      },
                      expression: "detalhe_titulo.nm_devedor_cra"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.ativaCardEndereco,
                      expression: "ativaCardEndereco"
                    }
                  ],
                  staticClass: "pa-2"
                },
                [
                  _c("v-card-title", { staticClass: "mt-n4 primary--text" }, [
                    _vm._v("Endereço")
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      denses: "",
                      label: "Endereço Devedor Atual",
                      readonly: ""
                    },
                    model: {
                      value: _vm.detalhe_titulo.ds_endereco_devedor,
                      callback: function($$v) {
                        _vm.$set(_vm.detalhe_titulo, "ds_endereco_devedor", $$v)
                      },
                      expression: "detalhe_titulo.ds_endereco_devedor"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "data-cy": "enderecoAbreviado",
                      outlined: "",
                      dense: "",
                      label: "Endereço Devedor Abreviado",
                      counter: 45,
                      rules: [_vm.validadorNome.required, _vm.validadorNome.min]
                    },
                    model: {
                      value: _vm.detalhe_titulo.ds_endereco_devedor_cra,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.detalhe_titulo,
                          "ds_endereco_devedor_cra",
                          $$v
                        )
                      },
                      expression: "detalhe_titulo.ds_endereco_devedor_cra"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pa-4 mt-0", attrs: { justify: "end" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-5",
                      attrs: { dense: "", color: "error" },
                      on: { click: _vm.fechaConfirmacao }
                    },
                    [
                      _vm._v(" Cancelar "),
                      _c("v-icon", { staticClass: "ml-2" }, [_vm._v("cancel")])
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-5",
                      attrs: {
                        disabled: _vm.desabilitarConfirmacao(),
                        "data-cy": "confirmarCorrecao",
                        dense: "",
                        color: "success"
                      },
                      on: { click: _vm.correcaoConfirmacao }
                    },
                    [
                      _vm._v(" Confirmar "),
                      _c("v-icon", { staticClass: "ml-2" }, [_vm._v("done")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }